import { render, staticRenderFns } from "./MonthlyEPFAmbank.vue?vue&type=template&id=931d61d2&scoped=true"
import script from "./MonthlyEPFAmbank.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFAmbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931d61d2",
  null
  
)

export default component.exports